export default "__VITE_ASSET__365fe376__"